import React, { useState, useCallback, useEffect } from 'react'
import { Icon, Input } from 'semantic-ui-react';

const SearchInput = ({ data, searchType, handleResults, useDeepSearch }) => {

  const [filterValue, setFilterValue] = useState();
  const [hasSearched, setHasSearched] = useState();

  const filterData = useCallback(
    _.debounce((value) => {
      if (!value) {
        handleResults({ searchType, results: {} });
        return;
      }

      const lowercasedFilter = value.toLowerCase();

      // Recursive deep search
      const deepMatch = (obj) => {
        if (_.isNil(obj)) return false;

        if (_.isObject(obj)) {
          return _.some(obj, (val, key) => {
            const keyMatches = _.toString(key).toLowerCase().includes(lowercasedFilter);
            return keyMatches || deepMatch(val); // recurse
          });
        }

        return _.toString(obj).toLowerCase().includes(lowercasedFilter);
      };

      const results = _.mapValues(data, (category, parentKey) => {
        const parentKeyMatches = _.toString(parentKey)
          .toLowerCase()
          .includes(lowercasedFilter);

        if (parentKeyMatches) {
          return category; // keep whole category if parent matches
        }

        if (useDeepSearch) {
          // include whole category if ANY match inside it
          return deepMatch(category) ? category : {};
        } else {
          // shallow filter (your original version)
          return _.pickBy(category, (item, key) => {
            const keyMatches = _.toString(key).toLowerCase().includes(lowercasedFilter);
            const valueMatches = _.some(item, (val) =>
              _.toString(val).toLowerCase().includes(lowercasedFilter)
            );
            return keyMatches || valueMatches;
          });
        }
      });

      const filteredResults = _.pickBy(results, (category) => !_.isEmpty(category));
      setHasSearched(true)
      handleResults({ searchType, results: filteredResults });
    }, 300),
    [data]
  );

  // Effect to trigger debounced search
  useEffect(() => {
    if (filterValue) {
      filterData(filterValue);
    } else {
      if (hasSearched) {
        handleResults({ searchType, results: data }); // Return the entire dataset if no filter is applied
      }
    }
    return filterData.cancel; // Cancel debounce on cleanup
  }, [filterValue, filterData, data]);

  const searchInput = () => <Input
    icon={
      filterValue ? (
        <Icon
          name="delete"
          link
          color='grey'
          bordered
          inverted
          onClick={() => setFilterValue('')} // Clear filterValue on click
        />
      ) : (
        <Icon name="search" color='grey' bordered inverted />
      )
    }
    placeholder="Search..."
    value={filterValue}
    onChange={(e) => setFilterValue(e.target.value)}
    fluid
    style={{ marginBottom: "16px" }}
  />

  return searchInput()

}

export default SearchInput
